module.exports = "https://pm2019.reeltime.no/public/images/kjop_logo.08de8d53.png";